import dollar from "../assets/images/icons/dollar.svg";

const DonationHistory = ({ donations = [], totalAmount }) => {
    return (
        <div className="relative w-full rounded-2xl p-2">
            <div className="relative w-full bg-white p-3 rounded-2xl flex flex-col">
                
                {/* 1. Header (Stays at the top of the box) */}
                <div className="flex justify-between bg-[#D9D9D9] rounded-full px-5 py-3 mb-3 items-center">
                    <span className="text-[#000000] text-md font-semibold">Donations / Gift History</span>
                    <span className="font-semibold text-[22px] text-[#000000]">$ {totalAmount}</span>
                </div>

                {/* 2. Scrollable Container for ALL items */}
                <div className="relative">
                    <div className="max-h-[350px] overflow-y-auto 
                        [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                        
                        {donations.map((item, index) => (
                            <div 
                                key={item.id || index} 
                                className="flex justify-between py-3 border-b border-gray-100 last:border-0"
                            >
                                <div className="flex gap-3">
                                    <img
                                        src={item.avatar}
                                        alt={item.name}
                                        className="w-9 h-9 rounded-full object-cover"
                                    />
                                    <div>
                                        <p className="text-md font-semibold text-black">{item.name}</p>
                                        <p className="text-[10px] text-gray-500">{item.time}</p>
                                    </div>
                                </div>

                                <span className="flex items-center text-[#000000] text-[18px] font-medium px-3 py-1 border border-[#FF7A51] gap-2 rounded-full h-fit self-center go-to-live-history-dollar">
                                    <img src={dollar} alt="dollar icon" className="w-4 h-4" /> 
                                    {item.amount}
                                </span>
                            </div>
                        ))}
                        
                        {/* Extra bottom padding so the last item can clear the fade area */}
                        <div className="h-24"></div>
                    </div>

                    {/* 3. Bottom White Fade (50% height of the scroll area) */}
                    <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-white via-white/80 to-transparent pointer-events-none" />
                </div>
            </div>
        </div>
    );
};

export default DonationHistory;
